const logout = {
	logoutTitle: 'Opravdu chcete odhlásit z aplikace?',
};

const common = {
	addNext: 'Přidat další',
	agreement: 'Souhlas',
	approved: 'Ověřeno',
	appName: 'Kancelář',
	cancel: 'Zrušit',
	ceEmp: 'Zaměstnanec České pojištovny',
	change: 'Upravit',
	clientZone: 'Klienstka zóna',
	confirm: 'Potvrdit',
	copied: 'Zkopírováno!',
	createdAt: 'Datum vzniku',
	dateModified: 'Datum modifikace',
	day_one: '{{count}} den',
	day_few: '{{count}} dny',
	day_other: '{{count}} dní',
	more_one: '{{ count }} další',
	more_few: '{{ count }} další',
	more_other: '{{ count }} dalších',
	delete: 'Smazat',
	deleteConfirm: 'Potvrdit',
	detail: 'Detail',
	disposalAgency: 'Agentura likvidace',
	edit: 'Editovat',
	elkom: 'Elektronická komunikace',
	email: 'E-mail',
	emptyFormFields: 'Alespoň jedno z vyhledávacích kritérií musí být vyplněno.',
	endDate: 'Datum ukončení',
	filter: 'Filtrovat',
	from: 'Od',
	geEmp: 'Zaměstnanec Generali',
	lastChangeDate: 'Datum poslední změny',
	lastUpdate: 'Posledni aktualizace',
	linden: 'Lípa',
	loadNext: 'Načíst další',
	marketingAgreement: 'Marketingový souhlas',
	modifiedBy: 'Změnu provedl',
	name: 'Název',
	no: 'Ne',
	none: 'Žádný',
	noRecord: 'Nebyl nalezen žádný záznam',
	ok: 'OK',
	pref: 'Pref.',
	print: 'Tisk',
	resetButton: 'Vymazat kritéria',
	representativeFor: '(Zástup)',
	save: 'Uložit',
	score: 'Skóre',
	searchButton: 'Vyhledat',
	send: 'Odeslat',
	setDefault: 'Nastavit výchozí',
	show: 'Zobrazit',
	showAll: 'Zobrazit vše',
	source: 'Zdroj',
	sourceSystem: 'Zdrojový systém',
	spamAgreement: 'Souhlas se zasílaním nabídek',
	startDate: 'Datum počátku',
	status: 'Stav',
	systemMod: 'Modif. systém',
	to: 'Do',
	total: 'Celkem',
	unapproved: 'Neověřeno',
	user: 'Uživatel',
	yes: 'Ano',
	requiredFields: 'Povolené kombinace vyhledávání:',
	seller: 'Obchodník',
	ppz: 'Podobchodník',
	regionalManager: 'Regionální ředitel',
	districtManager: 'Oblastní ředitel',
	agency: 'Administrativa',
	manager: 'Manažer skupiny',
	guarantor: 'Garant',
	central: 'Centrála',
	tableBeforeSearch: 'Pro zobrazení záznamů zadejte vyhledávací kritéria.',
	copiedToClipboard: 'Úspěšně zkopírováno.',
	yesCapital: 'Ano',
	noCapital: 'Ne',
	export: 'Export',
	unwrap: 'Rozbalit',
	wrapUp: 'Sbalit',
	searchResults: 'Výsledek vyhledání',
	selectAll: 'Vybrat vše',
	continue: 'Pokračovat',
	add: 'Přidat',
};

const buttons = {
	logout: 'Odhlásit',
};

const warnings = {
	/* eslint-disable max-len */
	tooManyResults:
		'Počet výsledků k zobrazení je větší než 200. Zpřesněte filtrační kritéria a pokuste se zobrazení opakovat.',
	tooManyResultsPolicy:
		'Počet smluv k zobrazení je větší než 200. Zadejte, případně zpřesněte filtrovací kritéria a pokuste se zobrazení opakovat.',
	subsellerLoginAgencyNoAndWithSubordinatesConflict:
		'Nelze vyhledávat zároveň podle získatelského/agenturního čísla, loginu podobchodníka a včetně podřízených.',
	subsellerNotFound: 'Podobchodník nebyl nalezen.',
	atLeastOneContractTypeCheckboxSelected:
		'Pro vyhledávání musíte mít vybranou alespoň jednu společnost smlouvy - volby PS - GČP nebo PS - GP v sekci Kritéria pro zobrazení PS – pojistná smlouva.',
};

const errors = {
	validation_error: 'Vstupní požadavek neprošel validací',
};

const tabTitles = {
	gkcl: 'KCL',
	gkcl900: 'KCL Přihlášení',
	gkcl901: 'KCL Odhlášení',
	gkcl902: 'KCL Chyba přihlášení',
	gkcl903: 'KCL Chyba přihlášení v zástupu',
	gkcl904: 'KCL Chyba externího prokliku',
	gkcl905: 'KCL Nedostupnost aplikace',
};

export default {
	...logout,
	...common,
	...buttons,
	...warnings,
	...errors,
	...tabTitles,
};
